import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { Stack, Typography, Button, Paper } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CalendarFrame from '../../components/calendar/CalendarFrame';
import { useAuthStore } from '../../stores/root_store';

const CalendarViewTab = observer(() => {
  const authStore = useAuthStore();
  const navigate = useNavigate();

  if (!authStore.user?.has_calendar) {
    return (
      <Paper sx={{ m: 3, p: 4 }}>
        <Stack spacing={2} alignItems="flex-start">
          <Typography variant="h5">You haven't synced your calendar yet</Typography>
          <Typography variant="body1" color="text.secondary">
            Set your timezone and sync your calendar to get started.
          </Typography>
          <Button
            variant="contained"
            startIcon={<CalendarMonthIcon />}
            onClick={() => navigate('/settings/calendar')}
          >
            Set up your calendar
          </Button>
        </Stack>
      </Paper>
    );
  }

  return (
    <CalendarFrame
      showChrome={false}
      associatedType="current-user"
      associatedUuid={authStore.user.uuid}
    />
  );
});

export default CalendarViewTab;
